import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { register } from "../../Redux/actions/userActions.js";
import Loading from "../../components/Loading.jsx";
import Error from "../../components/Error.jsx";
import { useNavigate, Link } from "react-router-dom";
import { showToast } from "../../components/ToastMessage.jsx";
import { useSanitizedInput } from "../../hooks/useSanitizedInput.js";
import "./AuthScreens.css";

const RegisterScreen = () => {
  // ✅ Correct destructuring
  const [name, handleNameChange] = useSanitizedInput("", "alphanumeric");
  const [email, handleEmailChange] = useSanitizedInput("", "email");
  const [password, handlePasswordChange] = useSanitizedInput("", "text");
  const [confirmPassword, handleConfirmPasswordChange] = useSanitizedInput("", "text");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loading, error, userInfo } = useSelector((state) => state.auth);

  useEffect(() => {
    if (userInfo) {
      navigate("/");
      showToast("Registration successful!");
    }
  }, [userInfo, navigate]);

  const submitHandler = (e) => {
    e.preventDefault();
    
    // ✅ Frontend validation
    if (name.length < 2 || name.length > 100) {
      showToast("Name must be 2-100 characters", "error");
      return;
    }
    
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showToast("Please enter a valid email", "error");
      return;
    }
    
    if (password.length < 6) {
      showToast("Password must be at least 6 characters", "error");
      return;
    }
    
    if (password !== confirmPassword) {
      showToast("Passwords do not match", "error");
      return;
    }
    
    dispatch(register(name, email, password, confirmPassword));
  };

  return (
    <div className="auth-bg d-flex align-items-center justify-content-center">
      <div className="auth-card shadow-lg p-4 rounded-4">
        <h2 className="text-center mb-4 fw-bold text-teal">Create Account 🩺</h2>
        {error && <Error message={error} />}
        {loading && <Loading />}
        
        <form onSubmit={submitHandler}>
          <div className="mb-3">
            <label className="fw-semibold">Full Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter your full name"
              value={name}
              onChange={handleNameChange}
              maxLength="100"
              required
              disabled={loading}
            />
          </div>
          
          <div className="mb-3">
            <label className="fw-semibold">Email</label>
            <input
              type="email"
              className="form-control"
              placeholder="Enter your email"
              value={email}
              onChange={handleEmailChange}
              maxLength="100"
              required
              disabled={loading}
            />
          </div>
          
          <div className="mb-3">
            <label className="fw-semibold">Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Minimum 6 characters"
              value={password}
              onChange={handlePasswordChange}
              maxLength="128"
              minLength="6"
              required
              disabled={loading}
            />
          </div>

          <div className="mb-3">
            <label className="fw-semibold">Confirm Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Re-enter password"
              value={confirmPassword}
              onChange={handleConfirmPasswordChange}
              maxLength="128"
              minLength="6"
              required
              disabled={loading}
            />
          </div>

          <button type="submit" className="btn btn-teal w-100 mb-3" disabled={loading}>
            {loading ? "Creating account..." : "Register"}
          </button>

          <p className="text-center">
            Already registered?{" "}
            <Link to="/login" className="link-teal">Login here</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default RegisterScreen;